import { apiClient } from './api.client';
import type { components } from '../types/api.generated';
import { handleApiResponse, handleApiArrayResponse, handleApiVoidResponse } from './apiHelpers';

export type Loan = components['schemas']['Loan'];
export type CreateLoanRequest = components['schemas']['CreateLoanRequest'];
export type LoanPaymentRequest = components['schemas']['LoanPaymentRequest'];

export const loanService = {
  /**
   * Get all loans
   */
  async list() {
    const response = await apiClient.GET('/loans');
    return handleApiArrayResponse<Loan>(response as any);
  },

  /**
   * Get loan by ID
   */
  async get(id: string) {
    const response = await apiClient.GET('/loans/{id}', {
      params: { path: { id } }
    });
    return handleApiResponse<Loan>(response as any);
  },

  /**
   * Create new loan application
   */
  async create(loan: CreateLoanRequest) {
    const response = await apiClient.POST('/loans', {
      body: loan
    });
    return handleApiResponse<Loan>(response as any);
  },

  /**
   * Approve loan (board only)
   */
  async approve(id: string) {
    const response = await apiClient.POST('/loans/{id}/approve', {
      params: { path: { id } }
    });
    return handleApiResponse<Loan>(response as any);
  },

  /**
   * Reject loan (board only)
   */
  async reject(id: string) {
    const response = await apiClient.POST('/loans/{id}/reject', {
      params: { path: { id } }
    });
    return handleApiResponse<Loan>(response as any);
  },

  /**
   * Record loan payment
   */
  async recordPayment(id: string, payment: LoanPaymentRequest) {
    const response = await apiClient.POST('/loans/{id}/payments', {
      params: { path: { id } },
      body: payment
    });
    handleApiVoidResponse(response as any);
  }
};
